import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import { ImgInterface, ProductInterface } from "../../interfaces/product/product.interface";
import { LazyLoadImage } from 'react-lazy-load-image-component';

interface ImagesProps {
    product: ProductInterface;
}

export const Images: React.FC<ImagesProps> = ({ product }) => {
    const [nav1, setNav1] = useState<Slider | null>(null);
    const [nav2, setNav2] = useState<Slider | null>(null);
    const sliderRef = useRef<Slider>(null);
    const sliderMinRef = useRef<Slider>(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const containerRef = useRef<HTMLDivElement>(null);
    const [width, setWidth] = useState(0);

    const sliderSettings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
    };

    useEffect(() => {
        setNav1(sliderRef.current);
        setNav2(sliderMinRef.current);
    }, []);

    useEffect(() => {
        const handleResize = () => {
            if (containerRef.current) {
                setWidth(containerRef.current.offsetWidth);
            } else {
                setWidth(window.innerWidth - 30);
            }
        };

        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleImageLoad = () => {
        setIsLoaded(true);
    };

    return (
        <div
            ref={containerRef}
            className={`slider-container ${isLoaded ? 'loaded' : 'loading'} relative md:pb-[72px] pb-[25px]`}
            style={{ minHeight: width ? `${width + 29}px` : "auto" }}
        >
            <Slider
                asNavFor={nav2!}
                ref={sliderRef}
                {...sliderSettings}
                lazyLoad='progressive'
                className=""
            >
                {product.images.map((img: ImgInterface, i: number) => (
                    <div key={i} className="slide">
                        <div className="hidden md:flex items-center justify-center slick-slide-wrapper">
                            <LazyLoadImage
                                onLoad={handleImageLoad}
                                alt={product.name}
                                effect="blur"
                                src={img.big}
                                width={ width }
                                height={ width }
                                style={{ width: '100%', height: 'auto' }}
                                placeholderSrc={img.placeholder}
                            />
                        </div>
                        <div className="md:hidden flex items-center justify-center slick-slide-wrapper">
                            <LazyLoadImage
                                onLoad={handleImageLoad}
                                alt={product.name}
                                effect="blur"
                                src={img.small}
                                width={ width }
                                height={ width }
                                style={{ width: '100%', height: 'auto' }}
                                placeholderSrc={img.placeholder}
                            />
                        </div>
                    </div>
                ))}
            </Slider>
            <Slider
                className="minSlider mt-4 max-w-[800px]"
                asNavFor={nav1!}
                ref={sliderMinRef}
                {...sliderSettings}
                variableWidth={ true }
                centerMode={ true }
                focusOnSelect={ true }
                slidesToShow={ 1 }
                lazyLoad='progressive'
            >
                {product.images.map((img: ImgInterface, i: number) => (
                    <div key={i}>
                        <div className="hidden md:flex img">
                            <LazyLoadImage
                                width={ 72 }
                                height={ 72 }
                                src={ img.thumb }
                                alt={ product.name }
                            />
                        </div>
                        <div className="slideLine md:hidden"></div>
                    </div>
                ))}
            </Slider>
        </div>
    );
};

export default Images;
